@if(isLoading) {
    <div class="loading-container">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
} @else {
<div class="inspection-container">
    <mat-card class="card-container">
        <mat-card-content class="card-styling" [ngStyle]="{'justify-content': singleWide ? 'space-between' : 'center'}">
            <div class="zone-name">{{ zoneSelection }}</div>
            @if(singleWide) {
                <div>
                    <button class="sign-off-btn" [disabled]="inspectionValidCheck()" (click)="signOffInspection()">
                        {{ signOffBtnText }}
                    </button>
                </div>
            }
        </mat-card-content>
    </mat-card>

    <div>
        <mat-accordion multi>
            @for(section of sectionList; track section) {
                <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false"
                [expanded]="true" [expanded]="sectionList[0] === section">
                    <mat-expansion-panel-header>
                    <mat-panel-title class="section-title">
                        @if(!singleWide) {
                        {{ 'Section ' + section.SectionName }}
                            @if(!section.isComplete) {
                            <div>
                                <button class="section-signoff-btn" [disabled]="inspectionValidCheck(section.SectionId)" (click)="signOffInspection(section.SectionId)">
                                    {{ signOffBtnText }}
                                </button>
                            </div>
                            } @else {
                                <div class="section-complete-txt">Complete</div>
                            }
                        }
                    </mat-panel-title>
                    </mat-expansion-panel-header>
                    @for(station of section.Stations; track station) {
                    <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false"
                    class="station-accordion" [expanded]="true" [expanded]="section.Stations[0] === station">
                        <mat-expansion-panel-header>
                        <mat-panel-title class="station-title">
                            {{ station.Name }}
                        </mat-panel-title>
                        </mat-expansion-panel-header>
                        @if(openTasks) {
                            <open-defect-table [dataSource]="openTaskCheck(station.DefectedTasks)" [station]="station" 
                            (emitDesignateDefect)="onEmitDesignateDefectOpen($event, section, station.Id)"
                            (emitFixedDefect)="onEmitFixedDefectOpen($event, section, station.Id)"></open-defect-table>
                        }

                        <table multiTemplateDataRows mat-table [dataSource]="station.TaskExecutions" class="task-table">
                            <!-- Expansion Column -->
                            <ng-container matColumnDef="Expand">
                                <th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
                                <td mat-cell *matCellDef="let element">
                                @if(notPassCheck(element)) {
                                <button mat-icon-button aria-label="expand row" class="expand-btn"
                                (click)="(expandedElement = expandedElement === element ? null : element); $event.stopPropagation()">
                                    @if (expandedElement === element) {
                                    <mat-icon>keyboard_arrow_up</mat-icon>
                                    } @else {
                                    <mat-icon>keyboard_arrow_down</mat-icon>
                                    }
                                </button>
                                }
                                </td>
                            </ng-container>

                            @for (column of tableColumns; track column) {
                                @if(column === 'Checklist Item') {
                                    <!--- Name column -->
                                    <ng-container matColumnDef="Checklist Item">
                                        <th mat-header-cell *matHeaderCellDef class="name-column"> 
                                            <div class="checklist-header-style">
                                                {{checklistColumn}}
                                                <mat-icon (click)="showText = !showText" style="margin-right: 5px;">read_more</mat-icon> 
                                            </div>
                                        </th>
                                        <td mat-cell *matCellDef="let element" style="max-width: 12px;">
                                            @if(showText) {
                                                <div class="checklist-name">{{ element.TaskName }}</div>
                                            } @else {
                                                <div class="checklist-name-collapsed">{{ element.TaskName }}</div>
                                            }
                                        </td>
                                    </ng-container>
                                } @else if(column === 'Defect') {
                                    <!--- Defect column -->
                                    <ng-container matColumnDef="Defect">
                                        <th mat-header-cell *matHeaderCellDef class="check-box-column"> {{defectColumn}} </th>
                                        <td mat-cell *matCellDef="let element">
                                            <mat-checkbox
                                            [ngClass]="{ 'bueno': defectLocked(element, section) === true, 'malo': openDefects(element, section) === true }"
                                            [checked]="element.ResultValue === 'Defect'" 
                                            [disabled]="element.ResultValue === 'Pass' || element.ResultValue === 'NA' || completeCheck(section.SectionId) || defectLocked(element, section)"
                                            (change)="onCheckboxChange($event, element, 'defect', section.SectionId, station.Id)"></mat-checkbox>
                                        </td>
                                    </ng-container>
                                } @else if(column === 'NA') {
                                    <!--- NA column -->
                                    <ng-container matColumnDef="NA">
                                        <th mat-header-cell *matHeaderCellDef class="check-box-column"> {{naColumn}} </th>
                                        <td mat-cell *matCellDef="let element">
                                            <mat-checkbox class="na-chkbox"
                                            [checked]="element.ResultValue === 'NA'" 
                                            [disabled]="completeCheck(section.SectionId) || NADisableCheck(element) || isStringId(element.Id) "
                                            (change)="onCheckboxChange($event, element, 'na', section.SectionId, station.Id)"></mat-checkbox>
                                        </td>
                                    </ng-container>
                                } @else if(column === 'Pass') {
                                    <!--- Pass column -->
                                    <ng-container matColumnDef="Pass">
                                        <th mat-header-cell *matHeaderCellDef class="check-box-column"> {{passColumn}} </th>
                                        <td mat-cell *matCellDef="let element">
                                            <mat-checkbox 
                                            class="pass-chkbox"
                                            [checked]="element.ResultValue === 'Pass'" 
                                            [disabled]=" completeCheck(section.SectionId) || passDisableCheck(element) || isStringId(element.Id) "
                                            (change)="onCheckboxChange($event, element, 'pass', section.SectionId, station.Id)"></mat-checkbox>
                                        </td>
                                    </ng-container>
                                }
                            }

                        <!-- Expanded Content -->
                        <ng-container matColumnDef="expandedDetail">
                            <td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplayWithExpand.length">
                            <div class="example-element-detail"
                            [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                            @if(element.ResultValue === 'NA') {
                                <task-groups
                                    [type]="element.ResultValue"
                                    [completeCheck]="completeCheck(section.SectionId)" 
                                    [element]="element" 
                                    (emitNAComment)="handleNaComment($event, element)"
                                    (emitDNIStatus)="handleDNIStatus($event, element)"
                                    >
                                </task-groups>
                            } @if(element.ResultValue === 'Defect') {
                                    <mat-accordion class="defect-accordion">
                                        @for(defect of defectList; track defect.Id) {
                                            @if(defect.TaskExecutionId === element.Id && defect.IsDeleted !== true) {
                                            <defect-form [defect]="defect" [element]="element" [departments]="departments" [locations]="locations"
                                                (emitLocationChange)="onLocationChange($event, section.SectionId, element)"
                                                (emitQuantityChange)="onQuantityChange($event, section.SectionId, element)"
                                                (emitDescChange)="onDescriptionChange($event, section.SectionId, element)"
                                                (emitCompleteDefect)="onEmitCompleteDefect($event, section.SectionId, element)"
                                                (emitDesignateDefect)="onEmitDesignateDefect($event, section, element)"
                                                (emitRemoveDefect)="onRemoveIndividualDefect($event, section.SectionId, element)"></defect-form>
                                            }
                                        }
                                        @if(completeCheck(section.SectionId)) {

                                        } @else {
                                        <div class="add-defect-container">
                                            <button class="add-defect-btn" (click)="addDefect(element, section.SectionId)">
                                                {{addAdditionalDefectText}} <mat-icon class="add-circle">add_circle_outlined</mat-icon>
                                            </button>
                                        </div> 
                                        }
                                    </mat-accordion>
                                }
                            </div>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="columnsToDisplayWithExpand"></tr>
                        <tr mat-row *matRowDef="let element; columns: columnsToDisplayWithExpand;" [hidden]="naHiddenCheck(element)"
                            class="example-element-row"
                            [class.example-expanded-row]="expandedElement === element"
                            (click)="onExpandElement(element)">
                        </tr>
                        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row" [ngClass]="{ 'na-row': row.ResultValue === 'NA', 'defect-row': row.ResultValue === 'Defect', 'hide-row': row.valueToHide === true }"></tr>
                    </table>
                        <button class="observed-defect-btn" [disabled]="completeCheck(section.SectionId)" (click)="addObservedDefect(section.SectionId, station.Id)">
                        {{observedDefectTxt}}
                        </button> 
                       
                    </mat-expansion-panel>
                }
                </mat-expansion-panel>
            }
        </mat-accordion>
    </div>
</div>
}
